import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        eventId: 0,
        mos: window.mos,
        eventData: {},
        thirdPartyData: {
            validMos: false
        },
        isLoggedIn: false,
        cookie: '',
    },
    mutations: {
        updateEventData(state, data) {
            state.eventData = data
        },
        updateThirdPartyData(state, data) {
            state.thirdPartyData = data
        },
        loggedIn(state, status) {
            state.isLoggedIn = status
        },
        eventId(state, eventId) {
            state.eventId = eventId
        },
        tnewCookie(state, cookie) {
            state.cookie = cookie
        },
    },
    actions: {
       async fetchEventData({state, commit}) {
            return await fetch(`${window.env.PICKER_API_BASE_URL}/events/${state.eventId}`)
                .then(response => response.json())
                .then(data => {
                    commit('updateEventData', data)
                })
                .catch(error => console.log(error))
        },
        async fetchThirdPartyData({state, commit}) {
            return await fetch(`${window.site.AJAX}?${new URLSearchParams({
                action: 'basethemeThirdPartyEventMosValidation',
                eventId: state.eventId,
                modeOfSaleId: window.ModeOfSaleId,
            })}`)
                .then(response => response.json())
                .then(data => {
                    commit('updateThirdPartyData', data)
                })
                .catch(error => console.log(error))
        }
    }
})
export default store
